import React from "react"
import { useParams } from "react-router";
import { useScheduleSearchQuery } from "../../../../services/scheduleService/schedule-api";
import { ScheduleSearchCommand } from "../../../../services/scheduleService/commands";
import { Button, Dialog, DialogContent, DialogTitle, Stack, TextField } from "@mui/material";
import { ScheduleSearchResults } from "./ScheduleSearchResults";

function ScheduleSearch(){
    const [searchText, setSearchText] = React.useState('');
    const [open, setOpen] = React.useState(false);
    const [skip, setSkip] = React.useState(true);
    const {id} = useParams();
    const {data, error, isLoading} = useScheduleSearchQuery(new ScheduleSearchCommand(id!, searchText), {skip: skip});

    return <React.Fragment>
        <Stack direction='row'>
            <TextField 
                label='Patient Name or Account #' 
                name='searchText' 
                value={searchText}
                onChange={(e) => {setSearchText(e.currentTarget.value); setSkip(true);}}
                onKeyDown={(e) => {if (e.key === 'Enter') {setSkip(false); setOpen(true);}}}
                size='small' 
                sx={{backgroundColor: 'white'}}
            />
            <Button 
                color='primary' 
                variant="outlined" 
                onClick={() => {setSkip(false); setOpen(true);}} 
                disabled={searchText === ''} 
                size='small'
                >Search</Button>
        </Stack>

        <Dialog 
            open={open} 
            onClose={() => {setOpen(false)}} 
            maxWidth='xl'>

                <DialogTitle>Schedule Lookup</DialogTitle>
                <DialogContent>
                    {isLoading && <div>Loading...</div>}
                    {error && <div>Error: {error}</div>}
                    {data && 
                       
                        <ScheduleSearchResults data={data} />
                    }
                </DialogContent>
        </Dialog>
    </React.Fragment>
}
export {ScheduleSearch}